import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'

export default function ProtectedRoute() {
  const { session, isInitialised, isLoading } = useAppSelector((s) => s.auth)

  if (!isInitialised || isLoading) {
    return <div className="loading-screen" data-testid="loading-screen">Loading...</div>
  }

  if (!session) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
